export const LIGHTBOX_CLOSE = 'LIGHTBOX_CLOSE';
export const LIGHTBOX_OPEN = 'LIGHTBOX_OPEN';
export const LIGHTBOX_NEXT_IMAGE = 'LIGHTBOX_NEXT_IMAGE';
export const LIGHTBOX_PREVIOUS_IMAGE = 'LIGHTBOX_PREVIOUS_IMAGE';



// WEBPACK FOOTER //
// ./src/lightbox/types.js